import { Link } from "react-router-dom";
import styled from "styled-components";

export const TopNav = styled.div`
  display: flex;
  justify-content: center;
  padding: 15px;
  background-color: ${(props) => props.theme.backgroundColor};
`;

export const CustomLink = styled(Link)`
  color: #fff;
  text-decoration: none;
`;

export const SafeArea = styled.div`
  padding-left: 70px;

  @media (max-width: 400px) {
    padding-left: 60px;
  }
`;
